function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Button } from '../Button';
import { mapToFactory } from '../../utils';
import ReactConfigContext from '../../ReactConfigContext';
var toButtonVariant = mapToFactory({
    'button/primary': 'primary',
    'button/secondary': 'secondary',
    'button/border': 'border',
    'button/ghost': 'ghost',
    'button/link': 'link'
});
export default function CallToAction(_0) {
    var _0_variant = _0.variant, variant = _0_variant === void 0 ? 'button/primary' : _0_variant, buttonType = _0.buttonType, icon = _0.icon, label = _0.label, props = _object_without_properties(_0, [
        "variant",
        "buttonType",
        "icon",
        "label"
    ]);
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, props), {
        className: twMerge('inline-block', props.className)
    }), /*#__PURE__*/ React.createElement(Button, {
        icon: icon,
        type: buttonType !== null && buttonType !== void 0 ? buttonType : icon ? 'icon-after' : 'no-icon',
        variant: toButtonVariant(variant),
        className: "w-full"
    }, label));
}

//# sourceMappingURL=CallToAction.js.map